var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 19C36 9.61016 28.3898 2 19 2C9.61016 2 2 9.61016 2 19C2 28.3898 9.61016 36 19 36C28.3898 36 36 28.3898 36 19Z",
    fill: "#FCAF17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16.1665L25.7977 22.5909L26.4185 31L19 27.7813L11.5815 31L12.2023 22.5909L7 16.1665L14.7972 14.1882L19 7L23.1966 14.1882L31 16.1665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTips);
export default __webpack_public_path__ + "static/media/successTips.e3c879998f8fd976f4d90d86261fd320.svg";
export { ForwardRef as ReactComponent };